"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
function notifyApiErrorAction(errorApi, byPassAllowedCode, reportImmediatly) {
    return {
        type: types_1.NOTIFY_API_ERROR,
        payload: { errorApi: errorApi, byPassAllowedCode: byPassAllowedCode, reportImmediatly: reportImmediatly },
    };
}
exports.notifyApiErrorAction = notifyApiErrorAction;
function notifyErrorAction(errorJS, reportImmediatly) {
    return {
        type: types_1.NOTIFY_ERROR,
        payload: { errorJS: errorJS, reportImmediatly: reportImmediatly },
    };
}
exports.notifyErrorAction = notifyErrorAction;
function clearErrorAction() {
    return {
        type: types_1.CLEAR_ERROR
    };
}
exports.clearErrorAction = clearErrorAction;
function setConfigurationAction(config) {
    return {
        type: types_1.SET_CONFIGURATION,
        payload: config
    };
}
exports.setConfigurationAction = setConfigurationAction;
//# sourceMappingURL=Action.js.map